import { render, staticRenderFns } from "./ConfigAssistant.vue?vue&type=template&id=08327793&scoped=true"
import script from "./ConfigAssistant.vue?vue&type=script&lang=js"
export * from "./ConfigAssistant.vue?vue&type=script&lang=js"
import style0 from "./ConfigAssistant.vue?vue&type=style&index=0&id=08327793&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08327793",
  null
  
)

export default component.exports